import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'dount-chart',
})

export default class DountChart extends Vue {

    // --------------------------------------------------------------
    // Properties
    @Prop({default: 300})
    private width: any;

    @Prop({default: 200})
    private height: any;

    @Prop({default: 30})
    private diff: any;

    @Prop()
    private count: any;

    @Prop()
    private title: any;

    @Prop({default: 10})
    private margin: any;

    @Prop()
    private data: any;

    private tooltipData: any = null;

    @Watch('data')
    private dountChange(data: any) {
        this.drawDonut(data);
    }

    // -------------------------------------------------------------
    // Hooks

    private mounted() {
        this.drawDonut(this.data);
    }

    // ---------------------------------------------------------------
    // Methods
    private drawDonut(data: any) {
        d3.select(this.$el).select('svg').remove();
        const radius = Math.min(this.width, this.height) / 2 - this.margin;
        const tooltip = d3.select(this.$el).select('.chart-tooltip');
        const svg: any = d3.select(this.$el)
            .append('svg')
            .attr('width', this.width)
            .attr('height', this.height)
            .append('g')
            .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')');
        const pie = d3.pie()
            .value((d: any) => d.value);

        const color = d3.scaleLinear().domain([1, 10]).range(['#c1dbee' as any, '#00ace9' as any]);

        const arc: any = d3.arc()
            .innerRadius(radius - this.diff)
            .outerRadius(radius);
        const g = svg.selectAll('.arc')
            .data(pie(data))
            .enter().append('g');

        g.append('text')
            .attr('text-anchor', 'middle')
            .attr('font-size', '25px')
            .append('svg:tspan')
            .attr('x', 0)
            .text(this.count)
            .style('fill', '#535e67')
            .append('svg:tspan')
            .style('font-size', '11px')
            .attr('x', 0)
            .style('font-weight', '100')
            .attr('dy', 20)
            .text(this.title)
            .style('fill', '#000');

        const onHoverPath = (d: any) => {
            const mouseEvent = d3.event;
            this.tooltipData = d.data;
            tooltip.style('opacity', 1);
            tooltip.style('left', (mouseEvent.pageX + 10) + 'px');
            tooltip.style('top', (mouseEvent.pageY + 10) + 'px');
        };

        const onMouseLeavePath = (d: any) => {
            tooltip.style('opacity', 0);
        };

        svg.selectAll('arc')
            .data(pie(data))
            .enter()
            .append('path')
            .attr('d', arc)
            .attr('class', (d: any) => d.data.className)
            .style('opacity', 0.7)
            .style('fill', (d: any, i: any) => color(i))
            .on('mouseover', onHoverPath)
            .on('mouseleave', onMouseLeavePath);

    }

}
